module.exports = __webpack_public_path__ + "img/button-text-formatting.3818146.svg";